import {configureStore} from "@reduxjs/toolkit"
import requestReducer, {RequestDuckState} from "./request"
import env from "../config/env"
import footerReducer, {FooterDuckState} from "./footerdata"
import userReducer, {UserDuckState} from "./user"
import textReducer, {TextDuckState} from "./text"
import languageReducer, {LanguageDuckState} from "./languages"
import textAlignmentReducer from "./text-alignment"
import settingsReducer, {SettingsDuckState} from "./settings"
import templateReducer, {TemplateSettingsDuckState} from "./template"

const {DEVELOPMENT} = env

export interface State {
    user: UserDuckState
    request: RequestDuckState
    languages: LanguageDuckState
    data: FooterDuckState
    textAlignment: string
    text: TextDuckState
    settings: SettingsDuckState
    template: TemplateSettingsDuckState
}

export const rootReducer = {
    user: userReducer,
    request: requestReducer,
    languages: languageReducer,
    data: footerReducer,
    textAlignment: textAlignmentReducer,
    text: textReducer,
    settings: settingsReducer,
    template: templateReducer,
}

type Reducers = typeof rootReducer
type ActionTypes = {
    [K in keyof Reducers]: Parameters<Reducers[K]>[1]
}

export const makeStore = (initialState?: State) => {
    return configureStore<State, ActionTypes[keyof ActionTypes]>({
        reducer: rootReducer as any,
        devTools: DEVELOPMENT,
        preloadedState: initialState,
    })
}
